<template>
  <div 
    class="musicBox" 
    :class="isPlay ? 'play' : ''"
    @click="setAudioPlay"
  >
    <img :src="isPlay ? playIcon : pauseIcon" class="playMusicBtn"/>
    <audio :src="theMp3" loop ref="audio"></audio>
  </div>
</template>

<script>
import theMp3 from '@/assets/media/fsh.mp3'
import pauseIcon from '@/assets/img/pauseIcon.png'
import playIcon from '@/assets/img/playIcon.png'

export default {
  props: {
    nowPage: {
      type: Number,
      default: 0,
    }
  },
  data () {
    return {
      theMp3,
      isPlay: false, // 是否在播放
      playIcon, // 播放标志
      pauseIcon, // 暂停标志
      
    }
  },

  mounted () {
    // document.addEventListener('click', e => {
    //   console.log(e.target.className, e.target)
    //   if ( e.target.className != 'playMusicBtn' && this.nowPage === 0 ) {
    //     if ( this.isPlay === false ) {
    //       this.isPlay = true
    //       this.$refs.audio.play()
    //     }
    //   }
    // })
    this.setAudioPlay()
  },

  methods: {
    setAudioPlay () {
      if ( this.isPlay ) {
        this.isPlay = false
        this.$refs.audio.pause()
      } else {
        this.isPlay = true
        this.$refs.audio.play()
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.musicBox
  position fixed
  z-index 4
  right 83px
  bottom 180px
  width 65px
  height 65px
  background rgba( 201, 175, 152, .6)
  border-radius 50%
  cursor pointer
  img 
    display block
    width 100%
    height 100%
  &.play
    img 
      animation openIconDo 5s linear infinite forwards
@keyframes openIconDo
  0%
    transform rotate(0deg)
  100%
    transform rotate(360deg)
</style>